export default __webpack_public_path__ + "static/media/ads2.dc0b6ee6.png";